import apiClient from './client'

/**
 * API client per Magazzino (Inventory).
 * Gestisce giacenze prodotti, componenti, box, movimenti e lotti produzione.
 */

// ==================== GIACENZE PRODOTTI ====================

export const giacenzeProdottiApi = {
  /**
   * Lista giacenze prodotti
   * @param {Object} params - Filtri (categoria, search, ordering)
   */
  getAll: (params = {}) => apiClient.get('/inventory/giacenze-prodotti/', { params }),
  
  /**
   * Dettaglio giacenza prodotto
   * @param {number} id - ID giacenza
   */
  getById: (id) => apiClient.get(`/inventory/giacenze-prodotti/${id}/`),
  
  /**
   * Crea giacenza prodotto
   * @param {Object} data - { prodotto, quantita_disponibile, soglia_minima, ubicazione }
   */
  create: (data) => apiClient.post('/inventory/giacenze-prodotti/', data),
  
  /**
   * Aggiorna giacenza prodotto
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  update: (id, data) => apiClient.put(`/inventory/giacenze-prodotti/${id}/`, data),
  
  /**
   * Aggiornamento parziale giacenza
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  patch: (id, data) => apiClient.patch(`/inventory/giacenze-prodotti/${id}/`, data),
  
  /**
   * Elimina giacenza prodotto
   * @param {number} id - ID giacenza
   */
  delete: (id) => apiClient.delete(`/inventory/giacenze-prodotti/${id}/`),
  
  /**
   * Lista prodotti sottoscorta
   */
  sottoscorta: () => apiClient.get('/inventory/giacenze-prodotti/sottoscorta/'),

  /**
   * KPI valore vista corrente prodotti (aggregato, non paginato)
   * @param {Object} params - Filtri lista + metrica + stock_filter
   */
  valoreVista: (params = {}) => apiClient.get('/inventory/giacenze-prodotti/valore_vista/', { params }),
}

// ==================== GIACENZE COMPONENTI ====================

export const giacenzeComponentiApi = {
  /**
   * Lista giacenze componenti
   * @param {Object} params - Filtri (tipo, search, ordering)
   */
  getAll: (params = {}) => apiClient.get('/inventory/giacenze-componenti/', { params }),
  
  /**
   * Dettaglio giacenza componente
   * @param {number} id - ID giacenza
   */
  getById: (id) => apiClient.get(`/inventory/giacenze-componenti/${id}/`),
  
  /**
   * Crea giacenza componente
   * @param {Object} data - { componente, quantita_disponibile, soglia_minima, ubicazione }
   */
  create: (data) => apiClient.post('/inventory/giacenze-componenti/', data),
  
  /**
   * Aggiorna giacenza componente
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  update: (id, data) => apiClient.put(`/inventory/giacenze-componenti/${id}/`, data),
  
  /**
   * Aggiornamento parziale giacenza
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  patch: (id, data) => apiClient.patch(`/inventory/giacenze-componenti/${id}/`, data),
  
  /**
   * Elimina giacenza componente
   * @param {number} id - ID giacenza
   */
  delete: (id) => apiClient.delete(`/inventory/giacenze-componenti/${id}/`),
  
  /**
   * Lista componenti sottoscorta
   */
  sottoscorta: () => apiClient.get('/inventory/giacenze-componenti/sottoscorta/'),

  /**
   * KPI valore vista corrente componenti (aggregato, non paginato)
   * @param {Object} params - Filtri lista + metrica + stock_filter
   */
  valoreVista: (params = {}) => apiClient.get('/inventory/giacenze-componenti/valore_vista/', { params }),
}

// ==================== GIACENZE BOX ASSEMBLATE ====================

export const giacenzeBoxApi = {
  /**
   * Lista giacenze box assemblate
   * @param {Object} params - Filtri (search, ordering)
   */
  getAll: (params = {}) => apiClient.get('/inventory/giacenze-box/', { params }),
  
  /**
   * Dettaglio giacenza box
   * @param {number} id - ID giacenza
   */
  getById: (id) => apiClient.get(`/inventory/giacenze-box/${id}/`),
  
  /**
   * Crea giacenza box
   * @param {Object} data - { tipologia, quantita_disponibile, ubicazione }
   */
  create: (data) => apiClient.post('/inventory/giacenze-box/', data),
  
  /**
   * Aggiorna giacenza box
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  update: (id, data) => apiClient.put(`/inventory/giacenze-box/${id}/`, data),
  
  /**
   * Aggiornamento parziale giacenza
   * @param {number} id - ID giacenza
   * @param {Object} data - Dati da aggiornare
   */
  patch: (id, data) => apiClient.patch(`/inventory/giacenze-box/${id}/`, data),
  
  /**
   * Elimina giacenza box
   * @param {number} id - ID giacenza
   */
  delete: (id) => apiClient.delete(`/inventory/giacenze-box/${id}/`),

  /**
   * KPI valore vista corrente box (aggregato, non paginato)
   * @param {Object} params - Filtri lista + metrica + stock_filter
   */
  valoreVista: (params = {}) => apiClient.get('/inventory/giacenze-box/valore_vista/', { params }),
}

// ==================== MOVIMENTI MAGAZZINO ====================

export const movimentiApi = {
  riepilogoFlussi: (params = {}) => apiClient.get('/inventory/movimenti/riepilogo-flussi/', { params }),
  /**
   * Lista movimenti magazzino
   * @param {Object} params - Filtri (tipo, operatore, search, ordering)
   */
  getAll: (params = {}) => apiClient.get('/inventory/movimenti/', { params }),
  
  /**
   * Dettaglio movimento
   * @param {number} id - ID movimento
   */
  getById: (id) => apiClient.get(`/inventory/movimenti/${id}/`),
  
  /**
   * Crea movimento generico
   * @param {Object} data - { tipo, prodotto/componente/box, quantita, causale, operatore }
   */
  create: (data) => apiClient.post('/inventory/movimenti/', data),
  
  /**
   * Carico merce (shortcut)
   * @param {Object} data - { prodotto/componente/box, quantita, causale }
   */
  carico: (data) => apiClient.post('/inventory/movimenti/carico/', data),
  
  /**
   * Scarico merce (shortcut)
   * @param {Object} data - { prodotto/componente/box, quantita, causale }
   */
  scarico: (data) => apiClient.post('/inventory/movimenti/scarico/', data),
}

// ==================== LOTTI PRODUZIONE ====================

export const lottiProduzioneApi = {
  /**
   * Lista lotti produzione
   * @param {Object} params - Filtri (tipologia_box, search, ordering)
   */
  getAll: (params = {}) => apiClient.get('/inventory/lotti-produzione/', { params }),
  
  /**
   * Dettaglio lotto produzione
   * @param {number} id - ID lotto
   */
  getById: (id) => apiClient.get(`/inventory/lotti-produzione/${id}/`),
  
  /**
   * Crea lotto produzione (esegue assemblaggio automatico)
   * @param {Object} data - { codice, tipologia_box, quantita, operatore, costi }
   */
  create: (data) => apiClient.post('/inventory/lotti-produzione/', data),
  
  /**
   * Aggiorna lotto produzione
   * @param {number} id - ID lotto
   * @param {Object} data - Dati da aggiornare
   */
  update: (id, data) => apiClient.put(`/inventory/lotti-produzione/${id}/`, data),
  
  /**
   * Elimina lotto produzione
   * @param {number} id - ID lotto
   */
  delete: (id) => apiClient.delete(`/inventory/lotti-produzione/${id}/`),
}

// Export default per retrocompatibilità
export default {
  giacenzeProdotti: giacenzeProdottiApi,
  giacenzeComponenti: giacenzeComponentiApi,
  giacenzeBox: giacenzeBoxApi,
  movimenti: movimentiApi,
  lottiProduzione: lottiProduzioneApi,
}
